import WithRender from "../../templates/base/rangeAttribute.html";
import { mapGetters, mapActions } from "vuex";
import hash from "object-hash";
import { Decimal } from "decimal.js";
import { i18n } from "../../i18n";
import { getAllowedRangeString, isInRange } from "../../helpers/helpers";

export default WithRender({
  computed: {
    ...mapGetters([
      "getIsCimpressDefaultSelection",
      "getCimpressHiddenPageOptions"
    ]),
    // name: () => {
    //   return "Cost Center Number:";
    // },
    propSelected() {
      return this.propsData.type && this.propsData.type == "multiple"
        ? this.propsData.selected
        : this.propsData.selected[0];
    },
    ranges() {
      let ranges = JSON.parse(JSON.stringify(this.propsData.ranges));
      ranges = ranges.sort((a, b) => {
        return parseFloat(a.minimum) - parseFloat(b.minimum);
      });
      return ranges;
    },
    allowedRanges() {
      return getAllowedRangeString(this.ranges);
    },
    unitOfMeasure() {
      if (this.ranges) {
        return this.ranges[0].unitOfMeasure;
      }
      return "";
    },
    code: function () {
      return this.propsData.code;
    },
    isHiddenInFrontend: function () {
      return this.getCimpressHiddenPageOptions.indexOf(this.code) > -1;
    }
  },
  mounted() {
    this.value = this.propSelected;
  },
  data() {
    return {
      value: null
    };
  },
  watch: {
    // whenever propSelected changes, this function will run
    propSelected(newValue, oldValue) {
      this.value = newValue;
    }
  },
  methods: {
    ...mapActions(["setPageOption", "setCimpressHiddenPageOptions"]),
    applyValue: function () {
      if (!isInRange(this.value, this.ranges)) {
        this.$swal({
          text: i18n.t("Value is out of range. Please check allowed values"),
          icon: "error"
        });
        return;
      }
      this.setPageOption({
        value: this.value,
        layout: true,
        option: this.code,
        optionType: "main"
      });
    },

    getRangeKey(range) {
      return hash(range);
    },
    hidePageOptionInFrontend: function (event) {
      let hiddenPageOptions = this.getCimpressHiddenPageOptions;
      if (event.target.checked) {
        if (hiddenPageOptions.indexOf(this.code) == -1) {
          hiddenPageOptions.push(this.code);
        }
      } else {
        hiddenPageOptions = hiddenPageOptions.filter(val => val !== this.code);
      }
      this.setCimpressHiddenPageOptions(hiddenPageOptions);
    }
  },
  props: ["code", "propsData", "showName"]
});
